export const STEP = {
	SERVICE: "service",
	DATE: "date",
	TIME: "time",
	CLIENT: "client",
	REVIEW: "review",
	CONFIRMED: "confirmed",
};
